import ReactRailsUJS from "react_ujs";

import "javascripts/application";
import "stylesheets/registrations";

var componentRequireContext = require.context("components", true);
ReactRailsUJS.useContext(componentRequireContext);

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);

window.addEventListener("DOMContentLoaded", function() {
  document.getElementById("image-file").addEventListener("change", function(event) {
    const file = event.target.files[0];

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        document.getElementById("preview-image").src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  });
});
